<app-sexual-performance
  htmlTitle="<strong>Support Sexual Performance</strong> While Your Peptides Do the Long-Term Work"
  question="We strongly recommend including ED medication in your prescription. Would you like to add it to your treatment plan?"
>
  <p class="mb-4">
    Peptide therapy supports long-term optimization, but performance can vary along the way. ED medication helps support
    dependable blood flow and erection quality when you need it so confidence and intimacy don’t have to wait.
  </p>
  <p class="mb-4">
    We offer discreet, clinician-prescribed Sildenafil or Tadalafil for use as needed.This option gives you dependable
    erections and improved stamina when you want it, without interrupting your overall treatment plan.
  </p>
</app-sexual-performance>
